import React from "react";
import {CategoriesOperator} from "./CategoriesOperator";

export default React.memo(CategoriesOperator);
// export default CategoriesOperator;
